import React, { memo, useMemo, Suspense } from "react";
import { theme } from "uikit";
import { useTranslation } from "react-i18next";

import Map, { type PolygonList } from "../../../../../components/DispatcherMap";
import { useTypedSelector } from "../../../../../redux/store";

const BaseParkings: React.FC<BaseParkings.Props> = ({
	taxiServiceId,
}): JSX.Element => {
	const { t } = useTranslation();
	const lang = useTypedSelector((state) => state.session.language);
	const parkings = useTypedSelector(
		(state) => state.globalState.parking.data.subscription.basic,
	);

	const text = useMemo(
		() => t(`mainPage.archives.orders.modal.map.polygons.parking`),
		[t],
	);

	const value = useMemo<PolygonList | undefined>(
		() =>
			taxiServiceId
				? parkings
						.filter((item) => item?.taxiServiceId === taxiServiceId)
						.map((parking) => ({
							id: parking.id,
							name:
								`${text} ${parking.name?.[lang]}` ||
								Object.values(parking.name)?.[0],
							color: theme.colors.info,
							vertices: parking.vertices.map((v) => [
								v.lat,
								v.lng,
							]),
							editable: false,
						}))
				: parkings.map((parking) => ({
						id: parking.id,
						name:
							`${text} ${parking.name?.[lang]}` ||
							Object.values(parking.name)?.[0],
						color: theme.colors.info,
						vertices: parking.vertices.map((v) => [v.lat, v.lng]),
						editable: false,
				  })),
		[lang, parkings, taxiServiceId, text],
	);

	return (
		<Suspense>
			<Map.PolygonEditor value={value} editing={false} />
		</Suspense>
	);
};

declare namespace BaseParkings {
	interface Props {
		taxiServiceId?: number;
	}
}

export const Parkings = memo(BaseParkings);
export default BaseParkings;
